@if (player) {
    <app-image [display_flag]="true" [app_country_flag_width]="'1em'" [player]="player" [margin]="'0'" [width]="'42px'" [height]="'42px'"></app-image>
}
